import Translations from '../Translations';
import history from '../../history';
import React, {
    useState,
} from 'react';
import {
    Modal,
    Button,
    Message,
    Icon,
} from 'semantic-ui-react';

const ModalCompleteWarning = (props) => {

    const [open, setOpen] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const [isCheckoutCompleted, setIsCheckoutCompleted] = useState(false);
    const [error, setError] = useState(null);
    const isCheckout = props.isAllowUserCheckout === true;

    const handleCheckout = async () => {
        if (submitting) return;
        setSubmitting(true);
        setError(null);
        try {
            const result = await props.onCheckout();
            if (result instanceof Error || result === false) throw new Error('Selection was not checked out.');
            setIsCheckoutCompleted(true);
            if (props.onCheckoutCompleted) props.onCheckoutCompleted();
        } catch (checkoutError) {
            setError('Selection was not checked out. Please try again.');
            return;
        } finally {
            setSubmitting(false);
        }
        history.replace('/success');
    };

    return (
        <Modal
            open={open}
            dimmer="inverted"
            onClose={() => !submitting && setOpen(false)}
            trigger={(
                <Button
                    fluid
                    primary
                    disabled={props.disabled || submitting || isCheckoutCompleted}
                    onClick={() => setOpen(true)}
                >
                    {isCheckoutCompleted ? <Translations text="selection.checked_out" backup={"Checked out"} /> : isCheckout ? <Translations text="common.checkout" backup={"Checkout"} /> : <Translations text="common.done" backup={"I'm done!"} />}
                </Button>
            )}
        >
            {isCheckout && <Modal.Header><Translations text="selection.modal_checkout_title" backup={"Confirm Checkout"} /></Modal.Header>}
            <Modal.Content>
                {isCheckout ? (
                    isCheckoutCompleted || error ? (
                        <Message positive={isCheckoutCompleted} negative={Boolean(error)} icon>
                            <Icon name={isCheckoutCompleted ? 'thumbs up outline' : 'ban'} />
                            <Message.Content>
                                {isCheckoutCompleted
                                    ? <Translations text="selection.checkout_success" backup={"Your selection has been checked out successfully."} />
                                    : <Translations text="selection.checkout_error" backup={"Selection was not checked out. Please try again."} />}
                            </Message.Content>
                        </Message>
                    ) : (
                        <p><Translations text="selection.checkout_confirmation" backup={"Are you sure you want to check out? Once confirmed, you will no longer be able to change your benefit selections."} /></p>
                    )
                ) : (
                    <Message positive icon>
                        <Icon name='thumbs up outline' />
                        <Message.Content><Translations text="selection.selection_recorded" backup={"Your selections have been recorded but you will still be allowed to make changes before the selection period closes."} /><p>
                                <Translations text="selection.return_to_mobile_home" backup={"Press \"<\" to return to home page."} />
                            </p>
                        </Message.Content>
                    </Message>
                )}
            </Modal.Content>
            {isCheckout && (
                <Modal.Actions>
                    {isCheckoutCompleted ? (
                        <Button content={<Translations text="common.okay" backup={"Ok"} />} primary onClick={() => setOpen(false)} />
                    ) : (
                        <>
                            <Button content={<Translations text="common.cancel" backup={"Cancel"} />} secondary disabled={submitting} onClick={() => setOpen(false)} />
                            <Button
                                content={<Translations text="common.checkout" backup={"Checkout"} />}
                                primary
                                loading={submitting}
                                disabled={submitting}
                                onClick={handleCheckout}
                            />
                        </>
                    )}
                </Modal.Actions>
            )}
        </Modal>
    );

};

export default ModalCompleteWarning;
